import React, { Component } from "react";
import { Group, Line } from "react-konva";
import { connect } from "react-redux";
import { ManifoldStructureType, ManifoldType } from "../../lib/manifolds";

class ManifoldPipes extends Component{
  useNewSizes = true;
  state = this.getInitialState();

  get lowerOuterDirectPipeY() {
    const manifold = this.props["manifold"];
    return this.props["chamberHeight"] / 2 + this.props.getScaledValue(
      !manifold.isOutlet && manifold.manifoldSize.isolatorStubSize
        ? manifold.manifoldSize.isolatorStubSize / 12
        : manifold.manifoldSize.stub
    ) / 2;
  }

  get lowerInnerDirectPipeY() {
    const manifold = this.props["manifold"];
    return this.props["chamberHeight"] / 2 - this.props.getScaledValue(
      !manifold.isOutlet && manifold.manifoldSize.isolatorStubSize
        ? manifold.manifoldSize.isolatorStubSize / 12
        : manifold.manifoldSize.stub
    ) / 2;
  }

  get upperOuterDirectPipeY() {
    const manifold = this.props["manifold"];
    return this.lowerOuterDirectPipeY - this.props.getScaledValue(
      !manifold.isOutlet && manifold.manifoldSize.isolatorStubSize
        ? manifold.manifoldSize.isolatorStubSize / 12
        : manifold.manifoldSize.stub
    );
  }

  get upperInnerDirectPipeY() {
    const manifold = this.props["manifold"];
    return this.lowerInnerDirectPipeY + this.props.getScaledValue(
      !manifold.isOutlet && manifold.manifoldSize.isolatorStubSize
        ? manifold.manifoldSize.isolatorStubSize / 12
        : manifold.manifoldSize.stub
    );
  }

  get lowerInnerPipeX() {
    if (this.useNewSizes) {
      return this.halfStructureSize + this.props.getScaledValue(this.props["manifold"].manifoldSize.trunk) / 2;
    } else
      return this.halfStructureSize + this.props.getScaledValue(this.props["manifoldSize"][1]) / 2;
  }

  get lowerInnerPipeY() {
    if (this.useNewSizes)
      return this.props.chamberHeight / 2 + this.props.getScaledValue(this.props["manifold"].manifoldSize.stub) / 2;
    else
      return this.props.chamberHeight / 2 + this.props.getScaledValue(this.props["manifoldSize"][0]) / 2;
  }

  get lowerOuterPipeX() {
    if (this.useNewSizes)
      return this.halfStructureSize - this.props.getScaledValue(this.props["manifold"].manifoldSize.trunk) / 2;
    else
      return this.halfStructureSize - this.props.getScaledValue(this.props["manifoldSize"][1]) / 2;
  }

  get lowerOuterPipeY() {
    if (this.useNewSizes)
      return this.lowerInnerPipeY - this.props.getScaledValue(this.props["manifold"].manifoldSize.stub);
    else
      return this.lowerInnerPipeY - this.props.getScaledValue(this.props["manifoldSize"][0]);
  }

  get upperInnerPipeX() {
    if (this.useNewSizes)
      return this.halfStructureSize + this.props.getScaledValue(this.props["manifold"].manifoldSize.trunk) / 2;
    else
      return this.halfStructureSize + this.props.getScaledValue(this.props["manifoldSize"][1]) / 2;
  }

  get upperInnerPipeY() {
    if (this.useNewSizes)
      return this.lowerInnerPipeY - this.props.getScaledValue(this.props["manifold"].manifoldSize.stub);
    else
      return this.lowerInnerPipeY - this.props.getScaledValue(this.props["manifoldSize"][0]);
  }

  get upperOuterPipeX() {
    if (this.useNewSizes)
      return this.halfStructureSize - this.props.getScaledValue(this.props["manifold"].manifoldSize.trunk) / 2;
    else
      return this.halfStructureSize - this.props.getScaledValue(this.props["manifoldSize"][1]) / 2;
  }

  get upperOuterPipeY() {
    if (this.useNewSizes)
      return this.upperInnerPipeY + this.props.getScaledValue(this.props["manifold"].manifoldSize.stub);
    else
      return this.upperInnerPipeY + this.props.getScaledValue(this.props["manifoldSize"][0]);
  }

  get endSecondPipeX() {
    if (!this.props.manifold.hasSecondPipe)
      return 0;

    const rowIndex = this.props.manifold.assembly.find(asm => asm.structureType !== null).rowIndex;
    let col = this.props.manifold.letColumn;
    const row = this.props.chamberRows[rowIndex];
    const increment = this.props.manifold.isUpper ? -1 : 1;
    let chambersToCross = 0;
    col += increment;
    let nextChamber = row.chambers[col];
    while (nextChamber) {
      if (!nextChamber.active) {
        chambersToCross += 1;
        col += increment;
        nextChamber = row.chambers[col];
      } else break;
    }
    const chamberInstalledOffset = this.props.chamberType.length - this.props.chamberType.installedLength;
    const chamberGap = this.props.chamberType.length * chambersToCross - ( chamberInstalledOffset * ( chambersToCross - 1 ) );
    const scaledChamberGap = this.props.getScaledValue(chamberGap);

    const endCapInstalledOffset = this.props.chamberEndCapType.length - this.props.chamberEndCapType.installedLength;
    const endcapSpace = ( this.props.chamberEndCapType.length - endCapInstalledOffset ) * 2;
    const scaledEndcapSpace = this.props.getScaledValue(endcapSpace);

    const ttlLengthOfGap = scaledChamberGap - scaledEndcapSpace;

    let result = this.width - Math.abs(ttlLengthOfGap);

    return result;
  }

  get secondPipeInnerY() {
    return this.upperInnerDirectPipeY;
  }

  get secondPipeOuterY() {
    return this.upperOuterDirectPipeY;
  }

  get width() {
    return this.trunkSeparation;
  }

  get innerManifoldWidth() {
    return this.innerManifoldTrunkSeparation;
  }

  get trunkSeparation() {
    const trunkSep = this.props.manifold.getTrunkSeparation(
      this.props.chamberRows[this.props.manifold.letRow],
      this.props.chamberRows,
      this.props.manifoldSeparations,
      false,
      this.props.stoneBedSeparationDistance) || 0;
    return this.props.getScaledValue(trunkSep);
  }

  get innerManifoldTrunkSeparation() {
    const trunkSep = this.props.manifold.getTrunkSeparation(
      this.props.chamberRows[this.props.manifold.letRow],
      this.props.chamberRows,
      this.props.manifoldSeparations,
      false,
      1);
    return trunkSep;
  }

  get height() {
    return ( this.props.chamberHeight * this.props["manifold"].assembly.length ) +
      ( ( this.props["manifold"].assembly.length - 1 ) * this.props.rowSpacing );
  }

  get halfStructureSize() {
    return this.structureSize / 2;
  }

  get structureSize() {
    try {
      let part = this.props["manifold"]
        .assembly
        .find(part => part.rowIndex === this.props["manifold"].letRow);

      let nyloplastStructureSize, concreteStructureSize;
      nyloplastStructureSize = this.props["manifold"].manifoldSize.nyloplastStructureSize;
      concreteStructureSize = this.props["manifold"].manifoldSize.concreteStructureSize;

      if (!nyloplastStructureSize) {
        nyloplastStructureSize = 30;
      }
      if (!concreteStructureSize) {
        concreteStructureSize = 48;
      }
      switch (part.structureType) {
        case ManifoldStructureType.Nyloplast: //Nylo
          return this.props.getScaledValue(nyloplastStructureSize / 12);
        default:  //Concrete
          return this.props.getScaledValue(concreteStructureSize / 12);
      }
    } catch (exception) {
      console.error(`manifold-pipes.js structureSize() :: ${exception.message}`);
      return 0;
    }
  }

  getOverlappedManifoldHighlight() {
    return {
      showManifoldConflict: true,
      basingLineThickness: 0.5,
      structureRoundStrokeColor: "darkred",
      structureSquareStrokeColor: "darkred",
      structureNyloplastStrokeColor: "darkred",
      structureRoundFillColor: "orange",
      structureSquareFillColor: "orange",
      structureNyloplastFillColor: "orange",
      pipeLineStrokeWidth: 0.8,
      pipeLineColor: "red",
      reset: true,
      isOverlap: true,
      isMainManifold: false
    };
  }

  getCurrentManifoldHighlight() {
    return {
      showManifoldConflict: false,
      basingLineThickness: 0.1,
      structureRoundStrokeColor: "DarkRed",
      structureSquareStrokeColor: "DarkRed",
      structureNyloplastStrokeColor: "DarkRed",
      structureRoundFillColor: "Yellow",
      structureSquareFillColor: "Yellow",
      structureNyloplastFillColor: "Yellow",
      pipeLineStrokeWidth: 0.5,
      pipeLineColor: "#0078D4",
      reset: false,
      isOverlap: false,
      isMainManifold: true
    };
  }

  getInitialState() {
    return {
      showManifoldConflict: false,
      basingLineThickness: 0.1,
      structureRoundStrokeColor: "red",
      structureSquareStrokeColor: "red",
      structureNyloplastStrokeColor: "blue",
      structureRoundFillColor: "white",
      structureSquareFillColor: "white",
      structureNyloplastFillColor: "lightblue",
      pipeLineStrokeWidth: 0.5,
      pipeLineColor: "green",
      reset: false,
      isOverlap: false,
      isMainManifold: false
    };
  }

  resetState() {
    this.setState({ ...this.getInitialState() });
  }

  showOverlapHighlight() {
    if (
      this.props.overlappingManifold
      && this.props.isOverlapPresent
    ) {
      this.setState(this.getOverlappedManifoldHighlight());
    } else if (
      this.state.reset
      && !this.props.isOverlapPresent
    ) {
      if (this.state.isMain) {
        this.setState(this.getCurrentManifoldHighlight());
      } else {
        if (!this.props.isOverlapPresent) {
          this.resetState();
        }

      }
    }
  }

  showCurrentManifoldHighlight() {
    if (this.props["currentManifold"] && this.props["currentManifold"]._id === this.props["manifold"]._id) {
      if (!this.state.isOverlap) {
        this.setState(this.getCurrentManifoldHighlight());
      }
      this.showOverlapHighlight();
    } else {
      this.resetState();
    }
  }

  getOffsetX() {
    return 0;
  }

  getOffsetY( row ) {
    return row * this.props.chamberHeight + ( row * this.props.rowSpacing );
  }

  getManifoldAssembly() {
    const
      {
        innerGapLine,
        outerGapLine,
        innerLine,
        outerLine,
        verticalLowerLine,
        verticalUpperLine,
        lowerInnerCorner,
        lowerOuterCorner,
        upperInnerCorner,
        upperOuterCorner,
        lowerOuterBasinCorner,
        lowerInnerBasinCorner,
        upperOuterBasinCorner,
        upperInnerBasinCorner,
        verticalBasinUpperLine,
        verticalBasinLowerLine,
        innerSecondPipe,
        outerSecondPipe
      } = this.getManifoldAssemblyParts(),

      ManifoldPipeLine = ( { points, pipeColor } ) => <Line points={points}
                                                            stroke={pipeColor || this.state.pipeLineColor}
                                                            strokeWidth={this.props.getScaledValue(this.state.pipeLineStrokeWidth)} />,
      ManifoldGap = () => (
        <Group y={this.props.chamberHeight}>
          <ManifoldPipeLine points={outerGapLine} />
          <ManifoldPipeLine points={innerGapLine} />
        </Group>
      );

    return {
      ManifoldTeePipe: () => (
        <Group>
          <ManifoldPipeLine points={outerLine} />
          <ManifoldPipeLine points={lowerInnerCorner} />
          <ManifoldPipeLine points={upperInnerCorner} />
          <ManifoldGap />
        </Group>
      ),
      ManifoldStraightHorizontalPipe: () => (
        <Group>
          <ManifoldPipeLine points={outerLine} />
          <ManifoldPipeLine points={innerLine} />
          <ManifoldGap />
        </Group>
      ),
      ManifoldStraightVerticalPipe: () => (
        <Group>
          <ManifoldPipeLine points={verticalUpperLine} />
          <ManifoldPipeLine points={verticalLowerLine} />
        </Group>
      ),
      ManifoldBasinStraightVerticalPipe: () => (
        <Group>
          <ManifoldPipeLine points={verticalBasinUpperLine} />
          <ManifoldPipeLine points={verticalBasinLowerLine} />
        </Group>
      ),
      ManifoldSecondDirectPipe: ( { pipeColor, rowIndex } ) => (
        <Group>
          <ManifoldPipeLine points={outerSecondPipe} pipeColor={pipeColor} />
          <ManifoldPipeLine points={innerSecondPipe} pipeColor={pipeColor} />
        </Group>
      ),
      ManifoldLeftElbow: () => (
        <Group>
          <ManifoldPipeLine points={upperOuterCorner} />
          <ManifoldPipeLine points={upperInnerCorner} />
        </Group>
      ),
      ManifoldRightElbow: () => (
        <Group>
          <ManifoldPipeLine points={lowerOuterCorner} />
          <ManifoldPipeLine points={lowerInnerCorner} />
          <ManifoldGap />
        </Group>
      ),
      ManifoldBasinRightElbow: () => (
        <Group>
          <ManifoldPipeLine points={upperOuterBasinCorner} />
          <ManifoldPipeLine points={upperInnerBasinCorner} />
          <ManifoldGap />
        </Group>
      ),
      ManifoldBasinLeftElbow: () => (
        <Group>
          <ManifoldPipeLine points={lowerOuterBasinCorner} />
          <ManifoldPipeLine points={lowerInnerBasinCorner} />
        </Group>
      )
    };
  };

  getManifoldAssemblyParts = () => {
    const parts = {
      innerLine: [this.lowerInnerPipeX, 0, this.lowerInnerPipeX, this.props.chamberHeight],
      outerLine: [this.lowerOuterPipeX, 0, this.lowerOuterPipeX, this.props.chamberHeight],
      verticalUpperLine: [this.upperInnerPipeX, this.upperInnerPipeY, this.width, this.upperInnerPipeY],
      verticalLowerLine: [this.lowerInnerPipeX, this.lowerInnerPipeY, this.width, this.lowerInnerPipeY],
      verticalBasinUpperLine: [this.upperInnerPipeX, this.upperInnerDirectPipeY, this.width, this.upperInnerDirectPipeY],
      verticalBasinLowerLine: [this.upperInnerPipeX, this.lowerInnerDirectPipeY, this.width, this.lowerInnerDirectPipeY],
      upperInnerCorner: [this.upperInnerPipeX, 0, this.upperInnerPipeX, this.upperInnerPipeY, this.width, this.upperInnerPipeY],
      upperOuterCorner: [this.upperOuterPipeX, 0, this.upperOuterPipeX, this.upperOuterPipeY, this.width, this.upperOuterPipeY],
      upperInnerBasinCorner: [this.upperInnerPipeX, this.props.chamberHeight, this.upperInnerPipeX, this.upperInnerDirectPipeY, this.width, this.upperInnerDirectPipeY],
      upperOuterBasinCorner: [this.upperOuterPipeX, this.props.chamberHeight, this.upperOuterPipeX, this.upperOuterDirectPipeY, this.width, this.upperOuterDirectPipeY],
      lowerInnerCorner: [this.lowerInnerPipeX, this.props.chamberHeight, this.lowerInnerPipeX, this.lowerInnerPipeY, this.width, this.lowerInnerPipeY],
      lowerOuterCorner: [this.lowerOuterPipeX, this.props.chamberHeight, this.lowerOuterPipeX, this.lowerOuterPipeY, this.width, this.lowerOuterPipeY],
      lowerInnerBasinCorner: [this.lowerInnerPipeX, 0, this.lowerInnerPipeX, this.lowerInnerDirectPipeY, this.width, this.lowerInnerDirectPipeY],
      lowerOuterBasinCorner: [this.lowerOuterPipeX, 0, this.lowerOuterPipeX, this.lowerOuterDirectPipeY, this.width, this.lowerOuterDirectPipeY],
      innerGapLine: [this.lowerInnerPipeX, 0, this.lowerInnerPipeX, this.props.rowSpacing],
      outerGapLine: [this.lowerOuterPipeX, 0, this.lowerOuterPipeX, this.props.rowSpacing],
      innerSecondPipe: [this.width, this.secondPipeInnerY, this.endSecondPipeX, this.secondPipeInnerY],
      outerSecondPipe: [this.width, this.secondPipeOuterY, this.endSecondPipeX, this.secondPipeOuterY]
    };
    return parts;
  };

  componentDidUpdate( prevProps ) {
    if (this.props.manifoldEntry !== prevProps.manifoldEntry) {
      this.showCurrentManifoldHighlight();
    }
  }

  render() {
    const {
      ManifoldTeePipe,
      ManifoldStraightHorizontalPipe,
      ManifoldStraightVerticalPipe,
      ManifoldBasinStraightVerticalPipe,
      ManifoldLeftElbow,
      ManifoldRightElbow,
      ManifoldBasinLeftElbow,
      ManifoldBasinRightElbow,
      ManifoldSecondDirectPipe
    } = this.getManifoldAssembly();
    const { assembly } = this.props.manifold;
    return assembly
      .map(( part, key ) => {
        let
          x = this.getOffsetX(key),
          y = this.getOffsetY(key),
          groupProps = { x, y, key };
        const isIsolator = this.props.manifold.hasIsolator;

        switch (part.manifoldType) {
          case ManifoldType.TeePipe:
            return (
              <Group {...groupProps}>
                <ManifoldTeePipe />
              </Group> );
          case ManifoldType.StraightHorizontalPipe:
            return (
              <Group {...groupProps}>
                <ManifoldStraightHorizontalPipe />
              </Group> );
          case ManifoldType.StraightVerticalPipe:
            return part.structureType !== null && isIsolator
              ? this.props.manifold.hasSecondPipe
                ? (
                  <Group {...groupProps}>
                    <ManifoldBasinStraightVerticalPipe />
                    <ManifoldSecondDirectPipe row={part.rowIndex} />
                  </Group> )
                : (
                  <Group {...groupProps}>
                    <ManifoldBasinStraightVerticalPipe />
                  </Group>
                )
              : this.props.manifold.hasSecondPipe
                ? (
                  <Group {...groupProps}>
                    <ManifoldStraightVerticalPipe />
                    <ManifoldSecondDirectPipe row={part.rowIndex} />
                  </Group>
                ) : (
                  <Group {...groupProps}>
                    <ManifoldStraightVerticalPipe />
                  </Group> );
          case ManifoldType.LeftElbow:
            return part.structureType !== null
              ? this.props.manifold.hasSecondPipe
                ? (
                  <Group {...groupProps}>
                    <ManifoldBasinLeftElbow />
                    <ManifoldSecondDirectPipe row={part.rowIndex} />
                  </Group> )
                : (
                  <Group {...groupProps}>
                    <ManifoldBasinLeftElbow />
                  </Group> )
              : (
                <Group {...groupProps}>
                  <ManifoldLeftElbow />
                </Group> );
          case ManifoldType.RightElbow:
            return part.structureType !== null
              ? this.props.manifold.hasSecondPipe
                ? ( <Group {...groupProps}>
                  <ManifoldBasinRightElbow />
                  <ManifoldSecondDirectPipe row={part.rowIndex} />
                </Group> )
                : (
                  <Group {...groupProps}>
                    <ManifoldBasinRightElbow />
                  </Group> )
              : (
                <Group {...groupProps}>
                  <ManifoldRightElbow />
                </Group> );
          default:
            return null;
        }
      });
  }
}

export default connect(
)(ManifoldPipes);



// WEBPACK FOOTER //
// ./src/components/Drawings/manifold-pipes.js